import { Login } from "@features/auth/auth";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/login/_guest/")({
	component: LoginComponent,
});

function LoginComponent() {
	return <Login />;
}
